import React, { Component } from 'react';
import Radium from 'radium';
import { Scrollbars } from 'react-custom-scrollbars';
import Usage from './Usage';
import Activities from './Activities';
import Description from './Description';
import DeliveryNotes from './DeliveryNotes';
import ControlAreas from './ControlArea/controlArea';
import Measurements from './Measurements';
import Remark from './Remark';

class DailyreportContainer extends Component {
  scrollToBottom = () => {
    this.refs.scrollbar.scrollToBottom()
  };

  render() {
    return (
      <div style={styles.container}>
        <Scrollbars
          ref="scrollbar"
          style={{ height: '100%', width: '100%' }}
          renderTrackHorizontal={props => <div {...props} className="track-horizontal" style={{ display: "none" }} />}
          renderThumbHorizontal={props => <div {...props} className="thumb-horizontal" style={{ display: "none" }} />}
        >
          <Description />
          <Activities />
          <DeliveryNotes />
          <Usage workplaceId={this.props.workplaceId} />
          <Measurements />
          <ControlAreas />
          <Remark scrollToBottom={this.scrollToBottom} />
        </Scrollbars>
      </div>
    );
  }
}

var styles = {
  container: {
    height: '100%'
  }
}

export default Radium(DailyreportContainer)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/dailyReportContainer.jsx